<template>
  <v-btn
    color="#00a0d0"
    size="large"
    prepend-icon="mdi-arrow-left"
    @click="handleBack"
  >
    Zpět
  </v-btn>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  fallbackUrl?: string
}>(), {
  fallbackUrl: '/'
})

function handleBack() {
  try {
    const hasInternalReferrer = document.referrer
      && new URL(document.referrer).hostname === window.location.hostname
    if (hasInternalReferrer && window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = props.fallbackUrl
    }
  } catch {
    window.location.href = props.fallbackUrl
  }
}
</script>
